
// Preferencias.tsx - SIN connect
import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import General from "./General";
import Datos from "./Datos";
import Indicadores from "./Indicadores";
import Versionamiento from "./Versionamiento";
import Seguridad from "./Seguridad";
import {
    CurrencyExchange,
    Database,
    Gear,
    Git,
    Shield,
    Sliders2,
} from "react-bootstrap-icons";

interface NavItem {
    name: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

interface PreferenciasProps {
    isDarkMode: boolean;
    activo: string;
    mostrarModal: boolean;
    setMostrarModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const Preferencias: React.FC<PreferenciasProps> = ({
    isDarkMode,
    activo,
    mostrarModal,
    setMostrarModal,
}) => {
    const [activeTab, setActiveTab] = useState(activo || "General");

    const navigation: NavItem[] = [
        { name: "General", icon: Sliders2 },
        { name: "Datos", icon: Database },
        { name: "Indicadores", icon: CurrencyExchange },
        // { name: "Firma", icon: Pen },
        { name: "Seguridad", icon: Shield },
        { name: "Versionamiento", icon: Git },
    ];

    const handleClick = (name: string) => {
        setActiveTab(name);
    };

    const getTabContent = () => {
        switch (activeTab) {
            case "General":
                return <General />;
            case "Datos":
                return <Datos />;
            // case "Firma":
            //     return <Firma />;
            case "Indicadores":
                return <Indicadores />;
            case "Seguridad":
                return <Seguridad />;
            case "Versionamiento":
                return <Versionamiento />;
            default:
                return <General />;
        }
    };

    const classNames = (
        ...classes: (string | boolean | undefined)[]
    ): string => classes.filter(Boolean).join(" ");

    return (
        <Modal
            size="xl"
            show={mostrarModal}
            onHide={() => setMostrarModal(false)}
            centered={false}
        >
            <Modal.Header
                className={isDarkMode ? "darkModePrincipal" : ""}
                closeButton
            >
                <Modal.Title> <Gear
                    className="me-3 flex-shrink-0"
                    aria-hidden="true"
                />Configuración y preferencias</Modal.Title>
            </Modal.Header>

            <Modal.Body
                className={isDarkMode ? "darkModePrincipal" : ""}
            >
                <Row>
                    <Col md={3}>
                        {navigation.map((item) => (
                            <button
                                key={item.name}
                                type="button"
                                onClick={() => handleClick(item.name)}
                                className={classNames(
                                    "fw-semibold btn d-flex align-items-center py-2 px-3 mb-2 rounded w-100 border-0",
                                    activeTab === item.name
                                        ? isDarkMode
                                            ? "btn-light"
                                            : "btn-secondary text-light"
                                        : isDarkMode
                                            ? "btn-dark text-light opacity-75"
                                            : "btn-light text-muted"
                                )}
                            >
                                <item.icon
                                    className="me-3 flex-shrink-0"
                                    aria-hidden="true"
                                />
                                {item.name}
                            </button>
                        ))}
                    </Col>

                    <Col md={9}>
                        {getTabContent()}
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default Preferencias;
